import Spinner from "@/components/Spinner/Spinner.vue";
import { mapGetters } from "vuex";
import candidatureService from "@/services/candidature";
import { RELANCE_CANDIDATURE_MESSAGE } from "@/constants/variables";
import Utils from "@/mixins/Utils";
import SectionTitle from "@/components/SectionTitle/SectionTitle.vue";
import documentService from "@/services/document";
export default {
  data() {
    return {
      guid: this.$route.query.id || "",
      title: "",
      content: "",
      buttonLabel: "",
      buttonUrl: "",
      loadingCand: false,
      interested: this.$route.query.interested || 0,
      vitallianceTitle: '',
    };
  },
  mixins: [Utils],
  components: {
    Spinner,
    SectionTitle,
  },
  computed: {
    ...mapGetters({
      errorMessage: "errorMessage",
      loadingSpinner: "isLoading",
      successMessage: "successMessage",
    }),
  },
  async created() {
    if (this.guid) {
      this.loadingCand = true;

      await candidatureService
        .checkRelanceCandidatureInfo(this.guid, this.interested)
        .then((res) => {
          if (!res.success) {
            this.updateErrorContent(res.message);
          } else {
            switch (res.message) {
              case RELANCE_CANDIDATURE_MESSAGE.RELANCE_NOT_INTERESTED_BUTTON: {
                this.updateContent({
                  title: this.$t("relance-not-interested-label"),
                  content: this.$t("relance-not-interested-text"),
                  buttonLabel: this.$t("relance-not-interested-button"),
                  buttonUrl: "relance-not-interested-button",
                }, "relance-not-interested-button");

                break;
              }

              case RELANCE_CANDIDATURE_MESSAGE.RELANCE_STILL_INTERESTED_TEXT: {
                this.updateContent({
                  title: this.$t("relance-still-interested-label"),
                  content: this.$t("relance-still-interested-text"),
                  buttonLabel: this.$t("relance-still-interested-button"),
                  buttonUrl: "relance-still-interested-button",
                }, "relance-still-interested-button");
                break;
              }
              default: {
                this.loadingCand = false;
                break;
              }
            }
          }
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            this.updateErrorContent(err.response.data.message);
          } else {
            this.updateErrorContent(RELANCE_CANDIDATURE_MESSAGE.RELANCE_ERROR_CONTENT)
          }
        });
    }
  },
  methods: {
    getVitallianceTitle(value) {
      switch (value) {
        case 'relance-not-interested-button': {
          this.vitallianceTitle = this.$t("relance-not-interested-first-label");
          break;
        }
        case 'relance-still-interested-button': {
          this.vitallianceTitle = this.$t("relance-still-interested-first-label");
          break;
        }
        case 'relance-unknown-error-button': {
          this.vitallianceTitle = this.$t("relance-unknown-error-first-label");
          break;
        }
        case 'relance-error-button': {
          this.vitallianceTitle = this.$t("relance-error-first-label");
          break;
        }
      }



    },
    updateErrorContent(message) {
      switch (message) {
        case RELANCE_CANDIDATURE_MESSAGE.RELANCE_ERROR_CONTENT: {
          this.updateContent({
            title: this.$t("relance-error-label"),
            content: this.$t("relance-error-content"),
            buttonLabel: this.$t("relance-error-button"),
            buttonUrl: "relance-error-button",
          }, "relance-error-button");
          break;
        }

        case RELANCE_CANDIDATURE_MESSAGE.RELANCE_UNKNOWN_ERROR_TEXT: {
          this.updateContent({
            title: this.$t("relance-unknown-error-label"),
            content: this.$t("relance-unknown-error-text"),
            buttonLabel: this.$t("relance-unknown-error-button"),
            buttonUrl: "relance-unknown-error-button",
          }, "relance-unknown-error-button");
        }
        default: {
          this.updateContent({
            title: this.$t("relance-error-label"),
            content: this.$t("relance-error-content"),
            buttonLabel: this.$t("relance-error-button"),
            buttonUrl: "relance-error-button",
          });
          break;
        }
      }
    },

    updateContent(value, vitaTitleKeyword = "") {
      this.title = value.title;
      this.content = value.content;
      this.buttonLabel = value.buttonLabel;
      this.getVitallianceTitle(vitaTitleKeyword);
      this.getButtonUrl(value.buttonUrl);
    },
    getButtonUrl(keyword) {
      documentService
        .getComponentBykeyword({ keyword: keyword, isBackground: true })
        .then((res) => {
          this.loadingCand = false;
          if (res && res.components) {
            this.buttonValue = res.components[0].valueUrl;
          }
        })
        .catch((err) => {
          this.loadingCand = false;
        });
    },

    redirectToPostTulerUrl() {
      if (this.buttonValue) {
        window.open(this.buttonValue, "_blank");
      }
    },
  },
};
